'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleTextArea = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _sharedFieldErrorWrapper = require('@bibliocommons/shared-field-error-wrapper');

var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseCharacterCount = require('@bibliocommons/base-character-count');

var _baseCharacterCount2 = _interopRequireDefault(_baseCharacterCount);

var _utilsBrowser = require('@bibliocommons/utils-browser');

require('../styles/AccessibleTextArea.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessibleTextArea = exports.AccessibleTextArea = function (_BcReactComponent) {
  _inherits(AccessibleTextArea, _BcReactComponent);

  function AccessibleTextArea(props) {
    _classCallCheck(this, AccessibleTextArea);

    var _this = _possibleConstructorReturn(this, (AccessibleTextArea.__proto__ || Object.getPrototypeOf(AccessibleTextArea)).call(this, props));

    _this.state = {
      height: '0'
    };

    _this.bindAll('handleChange', 'handlePaste', 'getTextAreaStyle', 'updateHeightToFitText');
    return _this;
  }

  _createClass(AccessibleTextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fitToText) {
        this.updateHeightToFitText();
      }
    }
  }, {
    key: 'getTextAreaStyle',
    value: function getTextAreaStyle() {
      if (!this.state.height || !this.props.fitToText) {
        return {};
      }
      return { height: this.state.height + 'px', overflow: 'hidden' };
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      var value = this._textarea.value;

      if (this.props.handleChange) {
        this.props.handleChange(value);
      }

      if (this.props.fitToText) {
        this.updateHeightToFitText();
      }
    }
  }, {
    key: 'handlePaste',
    value: function handlePaste(e) {
      var value = (0, _utilsBrowser.getTextFromPasteEvent)(e);

      if (this.props.handlePaste) {
        this.props.handlePaste(value);
      }
    }
  }, {
    key: 'updateRemainingCount',
    value: function updateRemainingCount(charactersUsed) {
      this.setState({
        remainingCount: this.props.maxLength - charactersUsed || 0
      });
    }
  }, {
    key: 'updateHeightToFitText',
    value: function updateHeightToFitText() {
      var _this2 = this;

      // Set the height to 0 so scrollHeight will reflect true height of text
      // (this is necessary because the scrollHeight is not updated when text is removed)
      // See http://bdadam.com/blog/automatically-adapting-the-height-textarea.html
      this.setState({ height: '0' }, function () {
        _this2.setState({ height: '' + _this2._textarea.scrollHeight });
      });
    }
  }, {
    key: 'renderCharacterCount',
    value: function renderCharacterCount() {
      var _props = this.props,
          value = _props.value,
          suggestedMaxLength = _props.suggestedMaxLength,
          maxLength = _props.maxLength;

      if (suggestedMaxLength || maxLength) {
        return _react2.default.createElement(_baseCharacterCount2.default, {
          count: value ? value.length : 0,
          limit: suggestedMaxLength || maxLength });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          defaultValue = _props2.defaultValue,
          placeholder = _props2.placeholder,
          className = _props2.className,
          labelledById = _props2.labelledById,
          describedById = _props2.describedById,
          disabled = _props2.disabled,
          required = _props2.required,
          maxLength = _props2.maxLength,
          name = _props2.name,
          handleFocus = _props2.handleFocus,
          handleBlur = _props2.handleBlur,
          setFocus = _props2.setFocus,
          testId = _props2.testId;

      var textAreaClass = 'form-control ' + className;

      var textAreaProps = (0, _omit2.default)(this.props, ['labelledById', 'describedById', 'disabled', 'fitToText', 'required', 'suggestedMaxLength', 'maxLength', 'name', 'className', 'setFocus', 'placeholder', 'value', 'defaultValue', 'testId', 'handleChange', 'handlePaste', 'handleFocus', 'handleBlur', 'intl']);

      return _react2.default.createElement(
        'div',
        { className: 'cp-accessible-text-area clearfix' },
        _react2.default.createElement('textarea', _extends({
          className: textAreaClass,
          'aria-labelledby': labelledById,
          'aria-describedby': describedById,
          placeholder: placeholder,
          defaultValue: defaultValue,
          value: value,
          disabled: disabled,
          maxLength: maxLength,
          required: required,
          name: name,
          ref: function ref(el) {
            _this3._textarea = el;
          },
          onChange: this.handleChange,
          onPaste: this.handlePaste,
          onFocus: handleFocus,
          onBlur: handleBlur,
          autoFocus: setFocus,
          'data-test-id': testId,
          style: this.getTextAreaStyle()
        }, textAreaProps)),
        this.renderCharacterCount()
      );
    }
  }]);

  return AccessibleTextArea;
}(_baseBcReactComponent2.default);

AccessibleTextArea.propTypes = {
  id: _react.PropTypes.string,
  labelledById: _react.PropTypes.string.isRequired,
  describedById: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  fitToText: _react.PropTypes.bool,
  required: _react.PropTypes.bool,
  suggestedMaxLength: _react.PropTypes.number,
  maxLength: _react.PropTypes.number,
  name: _react.PropTypes.string,
  className: _react.PropTypes.string,
  setFocus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  value: _react.PropTypes.string,
  defaultValue: _react.PropTypes.string,
  testId: _react.PropTypes.string,
  handleChange: _react.PropTypes.func,
  handlePaste: _react.PropTypes.func,
  handleFocus: _react.PropTypes.func,
  handleBlur: _react.PropTypes.func
};

AccessibleTextArea.defaultProps = {
  className: '',
  fitToText: false
};

exports.default = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextArea);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-text-area/lib/components/AccessibleTextArea.component.js
// module id = 1012
// module chunks = 1